import {ItemsLoader} from 'vuex-loopback';
import UniversalLink from '@src/components/link/universal-link';

export default ({Vue}) => {

  Vue.component(ItemsLoader.name, ItemsLoader);
  Vue.component(UniversalLink.name, UniversalLink);
};
